// src/pages/TableCitoyens.jsx
import React from "react";
import Layout from "../components/Layout";
import MeetingRoomManager from "../components/Manager/MeetingRoomManager";

function MeetingRoomManagers() {
  
  return (
    <Layout >
      <div className="p-6">
        <MeetingRoomManager />
      </div>
    </Layout>
  );
}

export default MeetingRoomManagers;
